import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {closeMobileMenu} from '../../actions/mobileMenu'

const MobileMenuClose = (props) => (
  <button className="mobile-menu-close" onClick={props.closeMobileMenu}>
    <span className="u-sr-only">Close mobile menu</span>
    <svg className="mobile-menu-close-icon">
      <use xlinkHref="#icon-close" />
    </svg>
  </button>
)

MobileMenuClose.propTypes = {
  closeMobileMenu: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => ({
  closeMobileMenu: () => dispatch(closeMobileMenu()),
})

export default connect(null, mapDispatchToProps)(MobileMenuClose)
